<template>
    <v-card tile>
        <v-tabs
        v-model="tab"
        background-color="primary"
        dark
        center-active
        show-arrows
        >
            <v-tab>Job Details</v-tab>
            <v-tab>Comments</v-tab>
            <v-tab>Images</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item>
                <v-card flat tile class="primary">
                    <v-card-text>
                        <ValidationObserver ref="observer1">
                            <v-form ref="jobFields">
                                <v-list flat>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <ValidationProvider v-slot="{ errors }" name="Customer" rules="required">
                                                <v-autocomplete
                                                    v-model="form.customer"
                                                    :items="customers"
                                                    :loading="isLoading"
                                                    :search-input.sync="search"
                                                    hide-no-data
                                                    hide-selected
                                                    item-text="label"
                                                    item-value="value"
                                                    label="Customer"
                                                    placeholder="Start typing to Search"
                                                    prepend-icon="mdi-database-search"
                                                    return-object
                                                    required
                                                    :error-messages="errors"
                                                ></v-autocomplete>
                                            </ValidationProvider>

                                            <ValidationProvider v-slot="{ errors }" name="Cleaner" rules="required">
                                                <v-select
                                                    v-model="form.cleaner"
                                                    :items="cleaners"
                                                    item-text="label"
                                                    item-value="value"
                                                    label="Cleaner"
                                                    required
                                                    :error-messages="errors"
                                                ></v-select>
                                            </ValidationProvider>

                                            <v-datetime-picker 
                                                label="Job Date/Time" 
                                                v-model="form.datetime" 
                                                date-format="MM/dd/yyyy" 
                                                time-format="hh:mm a"
                                            ></v-datetime-picker>

                                            <ValidationProvider v-slot="{ errors }" name="Status" rules="required">
                                                <v-select
                                                    v-model="form.status"
                                                    :items="filteredStatuses"
                                                    item-text="label"
                                                    item-value="value"
                                                    label="Status"
                                                    required
                                                    :error-messages="errors"
                                                ></v-select>
                                            </ValidationProvider>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-form>
                        </ValidationObserver>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="admin-action">
                        <v-spacer></v-spacer>
                        <v-btn large text @click="submit" :loading="loading">Update</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions> 
                </v-card>
                <v-card flat>
                    <v-card-text>
                        <v-row>
                            <v-col
                                cols="12"
                                md="6"
                                v-for="(chemical, index) in form.chemicals" :key="`repeater-${index}`"
                            >
                                <div class="repeater">
                                    <v-select
                                        v-model="chemical.product"
                                        :items="chemicals"
                                        item-text="label"
                                        item-value="value"
                                        label="Product"
                                        @change="changeType(chemical.product, index)"
                                    ></v-select>
                                    <v-text-field v-model="chemical.qty" type="number" label="Quantity" append-outer-icon="add" @click:append-outer="increment(index)" prepend-icon="remove" @click:prepend="decrement(index)"></v-text-field>
                                    <v-select
                                        v-model="chemical.measurement_type"
                                        :items="measurement_types"
                                        label="Measurement Type"
                                    ></v-select>
                                    <v-btn class="mx-2" color="secondary" fab x-small dark @click="remove(index)" v-show="index || ( !index && form.chemicals.length > 1)">
                                        <v-icon dark>mdi-minus</v-icon>
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="row-action">
                        <v-spacer></v-spacer>
                        <v-btn large text @click="add" :loading="loading">Add New Row</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions> 
                    <v-card-text class="secondary">
                        <v-textarea
                            v-model="form.comment"
                            label="Job Comments"
                            filled
                            hide-details
                            dark
                            color="white"
                        ></v-textarea>
                    </v-card-text>
                    <v-card-actions>                        
                        <v-btn large min-width="50%" color="blue darken-1" text to="/jobs">Cancel</v-btn>             
                        <v-btn large min-width="50%" color="primary" tile @click="submit" :loading="loading">Update</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>  
                </v-card>
            </v-tab-item>
            <v-tab-item>                
                <Comment v-for="(comment, index) in comments" :key="index" :item="comment" @set-parent="replyComment"/>
                <v-divider></v-divider>
                <v-card flat tile class="comment-form">
                    <v-card-text>
                        <v-form ref="commentform">
                            <v-chip
                            v-if="comment.parent"
                            class="mb-3"
                            close
                            @click:close="comment.parent = null"
                            small
                            >
                                Replying to: {{ activeComment | truncate(20, '...') }}
                            </v-chip>
                            <v-textarea
                                outlined
                                ref="comment"
                                v-model="comment.comment"
                                label="Comment"    
                                hide-details
                                auto-grow
                                rows="1"                             
                            ></v-textarea>
                            <v-checkbox
                                v-model="comment.public"
                                v-if="comment.parent == null"
                                label="Make Public & Notify Customer"
                                hide-details
                                class="mt-1 public"
                                ripple="false"
                            ></v-checkbox>
                        </v-form>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="admin-action">
                        <v-spacer></v-spacer>
                        <v-btn large text tile elevation="0" @click="sendComment" :loading="loading">Submit</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions> 
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat tile>
                    <v-card-text>
                        <file-pond
                            name="filepond"
                            ref="filepond"
                            label-idle='Drag & Drop your files or <span class="filepond--label-action"> Browse </span>'
                            v-bind:allow-multiple="true"
                            accepted-file-types="image/jpeg, image/png"
                            :server="{
                                url: 'https://api.mrpoolal.com/api/cleaners/job/image?id='+id,
                                process: {
                                    headers: {
                                        'Authorization': `Bearer ${token}`
                                    }
                                }
                            }"
                            v-bind:files="files"
                            v-on:init="handleFilePondInit"
                            v-on:processfile="handleFilePondProcessfile"/>
                    </v-card-text>
                 </v-card>
                <v-card flat tile>
                    <v-card-text>
                        <div v-viewer="voptions" class="images clearfix">
                            <template v-for="(source, index) in form.images">
                                <img :src="source.thumb" :data-source="source.src" class="image" :key="index">
                            </template>
                        </div>

                    </v-card-text>
                 </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import axios from 'axios'
import Comment from '../components/Comment.vue'
import TokenService from '../services/storage.service'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

export default {
    props: ['id'],
    data () {
        return {
            tab: null,
            files: [],
            uploadedFiles: [],
            form: {
                customer: {
                    label: '',
                    value: ''
                },
                cleaner: '',
                datetime: null,
                status: '',
                chemicals: [
                    {
                        product: '',
                        measurement_type: '',
                        qty: 1
                    }
                ],
                images: [],
                comment: ''
            },
            comments: [],
            loading: false,
            comment: {
                comment: '',
                public: false,
                parent: null,
                type: 'comment'
            },
            isLoading: false,
            search: null,
            customers: [],
            token: ''
        }
    },
    created() {
        this.getJob()
        this.token = TokenService.getToken()
    },
    watch: {
      search (val) {
        // Items have already been requested
        if (this.isLoading) return

        this.isLoading = true

        axios.get('admin/customers/search', {
            params: {
                keyword: val
            }
        })
        .then(response => {
            this.customers = response.data.customers
            this.$nextTick()
        })
        .catch(err => {
            console.log(err)
        })
        .finally(() => (this.isLoading = false))
      },
    },
    computed: {
        ...mapGetters({
            statuses: 'data/statusArray',
            cleaners: 'data/cleaners',
            chemicals: 'data/chemicals',
            measurement_types: 'data/measurement_types'
        }),
        filteredStatuses() {
            return this.statuses.filter(status => {
                return status.value != 'all'
            })
        },
        activeComment() {
            let active = this.comments.filter(comment => {
                return comment.id == this.comment.parent
            })

            if(active.length > 0) {
                return active[0].comment
            } else {
                return ''
            }
        },
    },
    components: {
        ValidationProvider,
        ValidationObserver,
        Comment
    },
    methods: {
        ...mapActions({
            updateJob: 'data/updateJob',
            addComment: 'data/addComment'
        }),
        getJob() {
            if(this.id) {
                axios.get('admin/jobs/get?id=' + this.id)
                    .then((response) => {
                        this.form.customer.label = response.data.job.customer.title
                        this.form.customer.value = response.data.job.customer_id
                        this.form.comment = response.data.job.comment
                        this.form.images = response.data.images
                        this.customers.push({...this.form.customer})
                        this.form.cleaner = response.data.job.user_id
                        this.comments = response.data.comments

                        if(response.data.job.job_data != null)
                            this.form.chemicals = JSON.parse(response.data.job.job_data)

                        if(response.data.job_time !== null)
                            this.form.datetime = new Date(response.data.job.job_time)

                        this.form.status = response.data.job.status
                        this.$nextTick()
                    })
            }
        },
        async submit() {
            let valid1 = await this.$refs.observer1.validate()

            if(valid1) {
                this.loading = true
                this.$set(this.form, 'id', this.id)
                this.updateJob(this.form).then(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                    this.$router.push({ path: '/jobs' })
                }).catch(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                })
            } else {
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Please check your form for the errors.')

                if(!valid1) {
                    this.tab = 0
                }
            }
        },
        async sendComment() {
            this.loading = true
            this.addComment({
                id: this.id, 
                comment: this.comment.comment, 
                public: this.comment.public, 
                parent: this.comment.parent,
                type: this.comment.type
            }).then(response => {
                this.loading = false
                if(response.parent) {
                    let filteredComment = this.comments.filter(comment => {
                        return comment.id == response.parent
                    })

                    filteredComment[0].children.unshift(response)
                } else {
                    this.comments.unshift(response)
                }
                this.comment.comment = ''
                this.comment.public = false
                this.comment.parent = null
                this.$store.commit('SET_SNACKTYPE', 'green')
                this.$store.commit('SET_SNACK', 'Successfully saved')
            }).catch(() => {
                this.loading = false
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Failed to save your comment! Please try again.')
            })
        },
        replyComment(parent, type) {
            this.comment.parent = parent
            this.comment.type = type
            const el = this.$el.getElementsByClassName('comment-form')[0]

            if (el) {
                el.scrollIntoView({behavior: 'smooth'})                
                this.$nextTick(() => this.$refs.comment.$refs.input.focus())
            }
        },
        add() {
            this.form.chemicals.push({                         
                product: '',
                measurement_type: '',
                qty: 1
            });
        },
        remove(index) {
            this.form.chemicals.splice(index, 1);
        },
        increment (index) {
            this.form.chemicals[index].qty = parseInt(this.form.chemicals[index].qty,10) + 1
        },
        decrement (index) {
            this.form.chemicals[index].qty = parseInt(this.form.chemicals[index].qty,10) - 1
        },
        handleFilePondProcessfile: function (error, file) {
            if(this.form.images !== undefined)
                this.form.images.push({
                    thumb: 'https://api.mrpoolal.com/img/backyards/' + file.serverId + '?w=400&h=400&fit=crop',
                    src: 'https://api.mrpoolal.com/img/backyards/' + file.serverId + '?w=1200',
                })  
                this.$nextTick()
        },
    }
}
</script>

<style lang="sass" scoped>
.admin-action 
    background: #1976d2
    button 
        width: 100%
        background: #ffffff
        color: #1976d2
.row-action
    background: #000
    button 
        width: 100%
        background: #ffffff
        color: #000
.comment-actions 
    background: #dadada
</style>
<style lang="sass">
.repeater
    padding: 30px 20px
    background: #eee
    margin: 10px 0
    text-align: center
    border-radius: 5px
</style>